module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加产品")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tagsList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.name) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "产品地址",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.url) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "图片地址",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "100px",
            "height": "60px"
          },
          attrs: {
            "src": scope.row.pic_url,
            "mode": "modeWidth"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "创建时间",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.time) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "保险公司",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.company) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.page_size) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.page_size
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑标签",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "产品名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入产品名称"
      },
      model: {
        value: (_vm.form.name),
        callback: function($$v) {
          _vm.$set(_vm.form, "name", $$v)
        },
        expression: "form.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "产品地址"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入产品地址"
      },
      model: {
        value: (_vm.form.url),
        callback: function($$v) {
          _vm.$set(_vm.form, "url", $$v)
        },
        expression: "form.url"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "保险公司"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入保险公司"
      },
      model: {
        value: (_vm.form.company),
        callback: function($$v) {
          _vm.$set(_vm.form, "company", $$v)
        },
        expression: "form.company"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "图片地址"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入图片地址"
      },
      model: {
        value: (_vm.form.pic_url),
        callback: function($$v) {
          _vm.$set(_vm.form, "pic_url", $$v)
        },
        expression: "form.pic_url"
      }
    })], 1), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo",
      attrs: {
        "multiple": true,
        "action": _vm.actionPath,
        "accept": "image/jpeg,image/png,image/gif",
        "show-file-list": false,
        "data": _vm.postData,
        "before-upload": _vm.beforeAvatarUpload,
        "on-success": _vm.handleAvatarSuccess
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("本地上传")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("只能上传jpg/png文件，且不超过2M")])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveTagData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23c636e1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c636e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/baoxian/insurance/insurance.vue
// module id = 2538
// module chunks = 0